

import thirt from '../assets/svg/projects/thirt.jpg'
import five from '../assets/svg/projects/five.jpg'

export const blogData = [
    {
        id: 1,
        title: 'Gyan Dhara ',
        description: 'A college counseling website provides students with valuable information and guidance on their higher education journey.  ',
        date: 'Jan 2021- Present',
        image: thirt,
        url: ''
    },
    {
        id: 2,
        title: 'Blog-Django',
        description: 'Build a blog website where we can upload different tech related information ',
        date: 'Dec 2021',
        image: five,
        url: ''
    },
    
    // {
    //     id: 3,
    //     title: 'Quirky Website -Commercial',
    //     description: 'Inspired from E coomericial Website',
    //     date: 'Feb  2022',
    //     image: '',
    //     url: ''
    // },
    
]



